import { datadogRum } from '@datadog/browser-rum';
import config from './config';
import connectivityFingerprint from './datadogConnectivityGrouping';
import isIgnoredRumError from './datadogIgnoredErrors';
import { hydrateDatadogUserContext } from './datadogUserTracking';

if (config.Environment === 'production') {
  datadogRum.init({
    applicationId: config.Datadog.ApplicationId,
    clientToken: config.Datadog.ClientToken,
    site: 'datadoghq.eu',
    service: 'web-app',
    env: config.Environment,
    version: config.AppVersion,
    sampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    trackInteractions: true,
    excludedActivityUrls: [/.*dataplane.rum.eu-west-1.amazonaws.com.*/],
    beforeSend: (event) => {
      // The SDK runs this straight from the collection path and guards it nowhere --
      // neither AbstractLifeCycle.notify nor limitModification wraps it -- so a throw here
      // surfaces wherever the event was collected, which for a console error is inside
      // application code. Classifying an error is never worth that, so any failure below
      // leaves the event exactly as the SDK built it.
      try {
        if (event.type !== 'error') {
          return true;
        }

        if (isIgnoredRumError(event.error.message)) {
          return false;
        }

        const fingerprint = connectivityFingerprint(event.error.message);
        if (fingerprint) {
          // Mutating the event in place is how beforeSend is meant to enrich it -- the SDK
          // reads back what this callback leaves behind, and returning a copy has no effect.
          // Both paths are on its modifiable list for error events; anything else it drops.
          /* eslint-disable no-param-reassign */
          event.error.fingerprint = fingerprint;
          // Answers "their connection or our backend?" for an error that reports no status.
          // Only the false case is conclusive: a browser reports online for any network it
          // can reach, including one with no route out of it.
          event.context = { ...event.context, browserReportedOffline: !navigator.onLine };
          /* eslint-enable no-param-reassign */
        }

        return true;
      } catch {
        return true;
      }
    },
  });

  hydrateDatadogUserContext();
}
